import { GoogleLocation, GroupInterface } from "@swivl-mono/types";

import { APIService } from "../Service/API.Service";

//LINK - apps/server/src/API/Group/Group.Controller.ts
export class GroupAPI {
  static async createGroup(orgId: number, group: Partial<GroupInterface>) {
    return APIService.Server.post<GroupInterface>(`/group/org/${orgId}/group`, group);
  }
}
